import { baseURL } from '../../config/config';
const campaignGroups = ['ADMIN', 'MANAGER', 'SALE_MANAGER', 'SALE_STAFF', 'MEDIA'];
export const canManageCampaigns = user => !!user && campaignGroups.includes(user.user_group);
export function coverSource(value) {
  if (/^\/document-campaign\/covers\/[a-f0-9]{32}\.(png|jpg|webp)$/.test(value)) return new URL(value, baseURL).href;
  return safeUrl(value) ? value : '';
}
export const nativeDefaultForm = () => ({ fields: ['parentName', 'parentPhone', 'email', 'childName', 'birthYear', 'birthDate', 'school', 'address', 'parentIdentity', 'childIdentity', 'childPhone', 'interest', 'source', 'notes'].map(key => ({ key, enabled: ['parentName', 'parentPhone', 'email', 'childName', 'birthYear', 'interest', 'source', 'notes'].includes(key), required: ['parentName', 'parentPhone'].includes(key) })) });
export const emptyDraft = () => ({ name: '', title: '', intro: '', coverUrl: '', resources: [{ name: '', url: '', description: '' }], benefits: [], provider: 'native', form: nativeDefaultForm(), formUrl: '', expiresAt: null, presentation: { showRegistrationCount: true, initialRegistrations: 50 } });
export const statusLabels = { draft: 'Bản nháp', published: 'Đang hoạt động', paused: 'Tạm dừng', expired: 'Đã hết hạn' };
export function safeUrl(value) {
  try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password; } catch (_) { return false; }
}
export function formUrl(value) {
  if (!safeUrl(value)) return '';
  const url = new URL(value);
  return url.hostname === 'docs.google.com' && !url.port && /^\/forms\/d\/(?:e\/)?[A-Za-z0-9_-]+\/viewform\/?$/.test(url.pathname) ? url.origin + url.pathname : '';
}
export function contentErrors(draft) {
  const errors = {};
  if (!draft.title.trim()) errors.title = 'Nhập tiêu đề trang.';
  if (!draft.name.trim()) errors.name = 'Nhập tên nội bộ.';
  if (draft.intro.length > 10000) errors.intro = 'Giới thiệu tối đa 10.000 ký tự. Nội dung chưa được lưu; vui lòng rút gọn.';
  if (!draft.resources.length) errors.resources = 'Thêm ít nhất một tài liệu.';
  draft.resources.forEach((r, i) => {
    if (!r.name.trim()) errors['resources.' + i + '.name'] = 'Nhập tên tài liệu.';
    if (!safeUrl(r.url)) errors['resources.' + i + '.url'] = 'Dùng đường dẫn HTTPS hợp lệ.';
    if (r.description.length > 10000) errors['resources.' + i + '.description'] = 'Mô tả tối đa 10.000 ký tự. Nội dung chưa được lưu; vui lòng rút gọn.';
  });
  if (draft.coverUrl && !coverSource(draft.coverUrl)) errors.coverUrl = 'Chọn ảnh bìa hoặc dùng đường dẫn HTTPS.';
  return errors;
}
export const confirmationText = draft => 'Cảm ơn bạn đã đăng ký nhận tài liệu từ SSStudy.\n\n' + draft.resources.map((r, i) => (i + 1) + '. ' + r.name + '\n' + r.url).join('\n\n') + '\n\nChúc bạn học tốt!';
export function campaignLink(slug, utm = {}) {
  const base = process.env.REACT_APP_CAMPAIGN_WEB_URL || 'https://ssstudy.vn';
  const url = new URL('/tai-lieu-mien-phi/' + slug, base);
  Object.keys(utm).forEach(k => { if (utm[k].trim()) url.searchParams.set(k, utm[k].trim()); });
  return url.href;
}
export function vietnamTime(value) {
  if (!value) return '';
  return new Date(new Date(value).getTime() + 7 * 3600000).toISOString().slice(0, 16);
}
